/* app/js/src/components/publishing-status/publishing-pagination-footer/publishing-pagination-footer.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  height: 50px;
  padding: 0 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
  align-self: stretch;
  flex-shrink: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background-color: rgb(255, 255, 255);
}
:host span {
  color: rgba(0, 0, 0, 0.85);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
:host .page-size {
  display: flex;
  align-items: center;
  gap: 10px;
}
:host .page-size > span {
  color: rgba(0, 0, 0, 0.54);
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select {
  height: 24px !important;
  width: 45px !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mdc-text-field {
  padding: 0 !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-select-value {
  width: fit-content !important;
  margin-right: 5px;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-infix {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mdc-line-ripple::after,
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mdc-line-ripple::before {
  border-bottom: none !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-select-arrow-wrapper {
  transform: none !important;
}
:host .pages-view {
  display: flex;
  align-items: center;
}
:host .pages-view span {
  margin-right: 6px;
}
:host .pages-view button {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  height: 20px;
  width: 20px;
  overflow: hidden;
  text-indent: 100%;
  appearance: none;
  border: 0;
  opacity: 0.54;
  padding: 0;
  cursor: pointer;
  background-color: transparent;
}
:host .pages-view button:nth-child(1) {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDRMOCA4bDQgNE00LjUgNHY4IiBzdHJva2U9IiM3RjhDOEQiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
}
:host .pages-view button:nth-child(2) {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkgNEw1IDhsNCA0IiBzdHJva2U9IiM3RjhDOEQiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
}
:host .pages-view button:nth-child(4) {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYgMTJsNC00LTQtNCIgc3Ryb2tlPSIjN0Y4QzhEIiBmaWxsPSJub25lIi8+PC9zdmc+);
}
:host .pages-view button:nth-child(5) {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQgMTJsNC00LTQtNG03LjUgOHY4IiBzdHJva2U9IiM3RjhDOEQiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
}
:host .pages-view button:hover:not(:disabled) {
  opacity: 0.87;
}
:host .pages-view button:disabled {
  opacity: 0.26;
  cursor: default;
}
/*# sourceMappingURL=publishing-pagination-footer.component.css.map */
